<template>
  <div class="payment-container">
    <v-container class="payment">
      <category-block
        :target="category"
        position="position1"
        class="category-block category-block-1"
      />
      <div class="checkout-title">
        <CategoryTitle
          :category="category"
          :showOnMobile="true"
          :centered="$vuetify.breakpoint.xs"
        />
      </div>

      <v-row>
        <v-col
          cols="12"
          md="4"
          lg="4"
          order="2"
          class="pt-0 d-flex flex-column"
        >
          <CheckoutSummary
            class="accent mb-6 mx-0 order-last order-sm-0"
            :orderCart="cart"
            @removeGiftCode="removeGift"
          />

          <TicketTypeList
            :cart="cart"
            mode="cart"
            :isPaymentDisabled="!billingFormCompletedInternal && invoiceNeeded"
          />

          <PaymentTypeList
            :options="paymentOptions"
            :isPaymentDisabled="!billingFormCompletedInternal"
            :paymentNameToPaymentInfo="true"
            :showAddNewCardWarningInfo="false"
            :portInfoFormNotCompleted="!portInfoFormCompletedInternal"
          />

          <PaymentButtons
            class="mt-2 mb-1"
            :options="paymentOptions"
            mode="cart"
            :isPaymentDisabled="!billingFormCompletedInternal"
            :portInfoFormNotCompleted="!portInfoFormCompletedInternal"
            :loading="loading"
            :hideGoBack="true"
            :backRoute="backRoute || '/checkout'"
            @confirm="handleConfirm"
            @goBack="handleGoBack"
          />
          <div
            v-if="$vuetify.breakpoint.xsOnly"
            style="position:relative;"
            class="my-2"
          >
            <CartInfoAddressCard
              class="cart-info-address-card"
              :shippingAddress="cart.shippingAddress"
              :editable="false"
            />
            <CartInfoTimeslotCard
              class="cart-info-timeslot-card"
              :shippingAddress="cart.shippingAddress"
              :timeslot="cart.timeslot"
              :editable="false"
              :value="timeslot"
            />
          </div>
        </v-col>
        <v-col cols="12" md="8" lg="8" class="pt-0" order="1">
          <v-row>
            <template v-if="$vuetify.breakpoint.smAndUp">
              <v-col cols="12" sm="6">
                <CartInfoAddressCard
                  class="w-100 cart-info-address-card"
                  :shippingAddress="cart.shippingAddress"
                  :editable="false"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <CartInfoTimeslotCard
                  class="w-100 cart-info-timeslot-card"
                  :shippingAddress="cart.shippingAddress"
                  :timeslot="cart.timeslot"
                  :editable="false"
                  :value="timeslot"
                />
              </v-col>
            </template>
            <v-col cols="12">
              <PaymentInvoice @billingFormCompleted="billingFormCompleted" />
            </v-col>
          </v-row>
          <PortInformations
            v-if="cart.shippingAddress.addressTypeId == 6"
            @portInfoCompleted="portInfoFormCompleted"
          />
          <div
            class="other-informations grey lighten-1 pa-4 mt-6 rounded-lg"
            v-if="cart.shippingAddress.addressTypeId == 2"
          >
            <h3 class="my-1 text-uppercase">
              {{ $t("paymentInvoice.additionalInfo") }}
            </h3>
            <!-- Notes -->
            <label v-html="`${$t('paymentInvoice.notes')}`" />
            <v-text-field
              :value="cart.cartInfos.notes"
              :placeholder="`${$t('paymentInvoice.notes')}`"
              hide-details="auto"
              maxlength="70"
              solo
              @blur="processOnboardChange('notes', $event.target.value)"
            />
          </div>

          <CollezionamentoSlider
            :timeslotId="cart.timeslot.date + cart.timeslot.timeslotId"
            :userId="cart.user.userId"
            :warehouseId="cart.warehouse.warehouseId"
            :layout="36"
            :limit="24"
            :lg="3"
            :xl="4"
            :paginationClass="'swiper-pagination-linea-220'"
            :showArrows="!$vuetify.breakpoint.xsOnly"
            :showBullets="$vuetify.breakpoint.xsOnly"
          >
            <h2 class="my-3 font-weight-regular text-uppercase">
              {{ $t("product.rewards") }}
            </h2>
          </CollezionamentoSlider>

          <div class="mb-3 px-3 px-sm-0">
            <PackagesTypeList
              :showTermal="
                cart.shippingAddress.deliveryServiceId != 2 &&
                  !(
                    cart.warehouse.metaData &&
                    cart.warehouse.metaData.warehouse_info &&
                    cart.warehouse.metaData.warehouse_info.HIDE_SPECIAL_PACKAGES
                  )
              "
            />
          </div>
        </v-col>
      </v-row>
      <category-block
        :target="category"
        position="position2"
        class="category-block category-block-2"
      />
    </v-container>
  </div>
</template>
<style scoped lang="scss">
.payment {
  .cart-info-timeslot-card,
  .cart-info-address-card {
    pointer-events: none;
    height: 60px;
  }
  .v-stepper {
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      max-width: 80%;
    }
  }
  .cart-info-timeslot-card {
    .value {
      text-transform: uppercase;
    }
  }
  .categoryDescription {
    .content {
      background-color: $white;
    }
    :deep(h2) {
      font-size: 14px;
      background-color: var(--v-default-lighten1);
      text-transform: uppercase;
      padding: 10px;
      line-height: 1.5;
    }
    :deep(p) {
      padding: 10px;
      font-size: 14px;
      color: var(--v-default-base);
    }
  }

  .payment-methods {
    background-color: var(--v-grey-lighten1) !important;
    padding: 16px !important;
    border-radius: 8px !important;
    :deep(p) {
      margin-bottom: 0px;
    }
    :deep(.text-h3) {
      font-weight: 600;
      font-size: 24px !important;
      text-transform: uppercase;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      :deep(.text-h3) {
        font-size: 18px !important;
      }
    }
    :deep(.v-expansion-panel) {
      background-color: var(--v-grey-lighten1) !important;
      border: 1px solid var(--v-grey-lighten1);
      padding: 0;
      border-radius: $border-radius-root;
      margin-bottom: 0px;
      &.v-expansion-panel--active {
        border-radius: $border-radius-root;
      }
      &:last-child {
        margin-bottom: 0px;
        border-top: none;
      }
      &::before {
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
      }
      .v-expansion-panel-header {
        background-color: var(--v-grey-lighten1);
        border-radius: $border-radius-root !important;
        padding-left: 0px;
        label {
          display: flex;
          align-items: center;
          padding-left: 20px;
        }
        .payment-method-img {
          height: 50px !important;
        }
      }
      .v-expansion-panel-content__wrap {
        padding: 0 !important;
        border-radius: $border-radius-root !important;

        .prebilled-amount {
          margin-bottom: 20px;
        }
        .caption {
          margin-top: 20px;
        }
      }

      .prebilledAmountInfo {
        margin-bottom: 20px;
        .text {
          color: var(--v-primary-lighten1);
        }
        .sub {
          font-size: 13px;
        }
      }
      label {
        text-transform: none;
        font-weight: 600;
      }
      // label:before {
      //   top: 15px;
      //   background: transparent;
      // }
      // label:after {
      //   top: 20px;
      // }
    }
    :deep(.ticket-type-list-content) {
      background-color: white !important;
    }
    :deep(.ticket-type-list) {
      background-color: white !important;
      border: 1px solid var(--v-grey-lighten1);
      padding: 0;
      border-radius: $border-radius-root;
      margin-bottom: 0px;
      &.v-expansion-panel--active {
        border-radius: $border-radius-root;
      }
      &:last-child {
        margin-bottom: 0px;
        border-top: none;
      }
      &::before {
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
      }
      .v-expansion-panel-header {
        background-color: white !important;
        border-radius: $border-radius-root !important;
        padding-left: 0px;
        label {
          display: flex;
          align-items: center;
          padding-left: 20px;
        }
        .payment-method-img {
          height: 50px !important;
        }
      }
      .v-expansion-panel-content {
        background-color: white !important;
      }
      .v-expansion-panel-content__wrap {
        background-color: white !important;
        padding: 12px 24px !important;
        border-radius: $border-radius-root !important;

        .prebilled-amount {
          margin-bottom: 20px;
        }
        .caption {
          margin-top: 20px;
        }
      }

      .prebilledAmountInfo {
        margin-bottom: 20px;
        .text {
          color: var(--v-primary-lighten1);
        }
        .sub {
          font-size: 13px;
        }
      }
      label {
        text-transform: none;
        font-weight: 600;
      }
      label:before {
        top: 15px;
        background: white;
      }
      label:after {
        top: 20px;
      }
    }
    :deep(.v-expansion-panel::after) {
      display: none;
    }
  }
  .other-informations {
    h3 {
      font-weight: 600;
      font-size: 24px;
    }
    label {
      font-weight: 600;
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
    :deep(.v-input__slot) {
      box-shadow: none !important;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      h3 {
        font-size: 18px;
      }
    }
  }
}
</style>
<script>
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import CheckoutSummary from "@/components/cart/CheckoutSummary.vue";
import CartInfoAddressCard from "@/components/cart/CartInfoAddressCard.vue";
import CartInfoTimeslotCard from "@/components/cart/CartInfoTimeslotCard.vue";
import PaymentTypeList from "~/components/payment/PaymentTypeList.vue";
import PaymentInvoice from "@/components/payment/PaymentInvoice.vue";
import PortInformations from "@/components/payment/PortInformations.vue";
import CollezionamentoSlider from "@/components/product/CollezionamentoSlider.vue";
import PackagesTypeList from "@/components/payment/PackagesTypeList.vue";
import TicketTypeList from "@/components/payment/TicketTypeList.vue";
import PaymentButtons from "@/commons/components/payment/PaymentButtons.vue";
import AnalyticsService from "~/service/analyticsService";

import productMixins from "~/mixins/product";
import login from "~/mixins/login";
import cartInfo from "~/mixins/cartInfo";
import categoryMixins from "~/mixins/category";

import { requiredValue, isEmail } from "~/validator/validationRules";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "Checkout",
  mixins: [login, productMixins, cartInfo, categoryMixins],
  components: {
    CategoryTitle,
    CheckoutSummary,
    CartInfoAddressCard,
    CartInfoTimeslotCard,
    PaymentTypeList,
    PaymentInvoice,
    CollezionamentoSlider,
    PackagesTypeList,
    TicketTypeList,
    PortInformations,
    PaymentButtons
  },
  data() {
    return {
      emailRules: [requiredValue("Digitare l'e-mail"), isEmail()],
      error: null,
      loading: false,
      billingFormCompletedInternal: true,
      portInfoFormCompletedInternal: true,
      emailKey: 1,
      showAlternativesTooltip: false,
      valid: false,
      sellCondition: false,
      paymentOptions: {
        showRememberCard: true,
        rememberCardDefaultValue: true,
        showPaymentMethodImage: true,
        showCardLogos: false,
        showPrebilledAmountInfoText: true,
        mainBackgroundColor: "transparent",
        confirm: {
          color: "primary",
          class: "w-100 d-block",
          label: this.$t("paymentTypeList.confirm"),
          large: true,
          depressed: true,
          block: true
        },
        back: {
          outline: true,
          class: "primary--text"
        },
        titleStyle:
          "payment-panels-title mb-3 text-body-1 font-weight-bold text-uppercase",
        hideButtons: true
      }
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    ...mapGetters({
      user: "cart/getUser"
    }),
    categoryDescription() {
      return this.$ebsn.meta(this.category, "category_info.DESCRIPTION");
    },
    fullAddress() {
      return (
        this.user.billingAddress.address1 +
        ", " +
        this.user.billingAddress.postalcode +
        " " +
        this.user.billingAddress.city +
        " (" +
        this.user.billingAddress.province +
        ")"
      );
    }
  },

  methods: {
    ...mapActions({
      lockCart: "cart/lockCart",
      setCartInfo: "cart/setCartInfo",
      removeGiftCode: "cart/removeGiftCode",
      loadCart: "cart/loadCart",
      getCart: "cart/getCart",
      addGiftCode: "cart/addGiftCode"
    }),
    async removeGift(gift) {
      await this.removeGiftCode(gift);
      // this.loadGiftCertificates();
    },
    billingFormCompleted(completed) {
      this.billingFormCompletedInternal = completed;
    },
    portInfoFormCompleted(completed) {
      this.portInfoFormCompletedInternal = completed;
    },
    processOnboardChange(name, value) {
      this.setCartInfo({ [name]: value });
    },
    async goToPayment() {
      let vm = this;
      vm.loading = true;
      try {
        if (await this.needAddress()) {
          if (await this.needTimeslot()) {
            await vm.lockCart();
            vm.$router.push({
              name: "Payment"
            });
          }
        }
      } catch (err) {
        await this.needTimeslot();
        vm.error = err.message;
      } finally {
        vm.loading = false;
      }
    }
  },
  mounted() {
    global.EventBus.$emit("triggerCloseMenu");
    AnalyticsService.beginCheckout(this.cart);
  }
};
</script>
